import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import properties from "../../../data/properties";

const Page = styled.div`
    width: 100%;
    background: #f7f7f7;
    padding: 170px 24px 110px;
`;

const Wrapper = styled.div`
    width: min(1200px, 100%);
    margin: 0 auto;
`;

const Header = styled.div`
    text-align: center;
    margin-bottom: 80px;
`;

const Title = styled.h1`
    font-size: clamp(2.6rem, 5vw, 4rem);
    font-weight: 300;
    letter-spacing: 2px;
    margin-bottom: 20px;
    color: #222;
`;

const Subtitle = styled.p`
    max-width: 720px;
    margin: 0 auto;
    font-size: 1.1rem;
    line-height: 1.9;
    color: #666;
`;

const PropertyGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 36px;

    @media (max-width: 1050px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
    cursor: pointer;

    background: white;
    border-radius: 14px;
    overflow: hidden;

    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
    transition: all 0.35s ease;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 18px 45px rgba(0, 0, 0, 0.15);
    }
`;

const ImageWrapper = styled.div`
    height: 260px;
    overflow: hidden;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;

    ${Card}:hover & {
        transform: scale(1.06);
    }
`;

const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 1;
`;

const CardTitle = styled.h2`
    font-size: 1.35rem;
    font-weight: 500;
    margin: 0 0 14px;
    color: #222;
`;

const CardText = styled.p`
    color: #666;
    line-height: 1.8;
    flex: 1;
`;

function AlleImmosPage() {
    const navigate = useNavigate();

    return (
        <Page>
            <Wrapper>
                <Header>
                    <Title>Unsere Immobilien</Title>

                    <Subtitle>
                        Entdecken Sie aktuelle Immobilienangebote in
                        Oberbayern und der Alpenregion – von Häusern über
                        Grundstücke bis hin zu Ferienimmobilien.
                    </Subtitle>
                </Header>

                <PropertyGrid>
                    {properties.map((property) => (
                        <Card
                            key={property.destination}
                            onClick={() => {
                                navigate(`/immobilie/${property.id}`);
                                window.scrollTo({ top: 0 });
                            }}
                        >
                            <ImageWrapper>
                                <Image
                                    src={property.heroImage}
                                    alt={property.title}
                                />
                            </ImageWrapper>

                            <CardBody>
                                <CardTitle>{property.title}</CardTitle>
                                <CardText>{property.text}</CardText>
                            </CardBody>
                        </Card>
                    ))}
                </PropertyGrid>
            </Wrapper>
        </Page>
    );
}

export default AlleImmosPage;